import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { UserService } from 'app/core/services/user.service';
import { Result } from 'app/core/models/result';
import { UserType } from '../../../account/models/user-type.model';
import { CompanyUser } from '../../../account/models/company-user.model';

@Component({
    selector: 'app-user-company-list',
    templateUrl: './user-company-list.component.html',
    styleUrls: ['./user-company-list.component.css']
})
export class UserCompanyListComponent implements OnInit {
    @Input() userId: string;
    @Input() isEditMode: boolean = false;
    @Output() userCompaniesUpdated: EventEmitter<string> = new EventEmitter<string>();
    selectedCompanyUserId: string;
    errors: string[];
    companies: CompanyListModel[];
    userTypes: UserType[];
    showUpdated: boolean;

    constructor(
        private userService: UserService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.userService.getCompanyUsers(this.userId).subscribe(
            companies => {
                this.companies = companies;
            },
            error => this.errors = error.errorList
        );
        this.userService.getUserTypes().subscribe(
            userTypes => this.userTypes = userTypes,
            error => {
                console.log(error);
            }
        );
    }

    deleteCompanyUser(): void {
        this.userService.deleteCompanyUser(this.selectedCompanyUserId).subscribe(
            result => {
                this.userCompaniesUpdated.emit("Updated");
                this.load();
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    updateCompanyUserType(company: CompanyUser, value: number) {
        if (company.userTypeId == value) {
            return;
        }

        let companyUser: CompanyUser = {
            id: company.id,
            companyId: company.companyId,
            siteUserId: company.siteUserId,
            userTypeId: value
        }

        this.userService.updateCompanyUserType(companyUser).subscribe(
            result => {
                this.userCompaniesUpdated.emit("Updated");
                this.load();
                this.showUpdated = true;
                setTimeout(() => {
                    this.showUpdated = false;
                }, 5000);
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    onUserCompanyAdded($event): void {
        this.userCompaniesUpdated.emit("Updated");
        this.load();
    }
}
